import type WorkHours from 'owa-service/lib/contract/WorkHours';
import type DayOfWeek from 'owa-service/lib/contract/DayOfWeek';
import type WorkTimeSlot from 'owa-service/lib/contract/WorkTimeSlot';
import type { BookingWorkHoursInput } from 'owa-graph-schema';
import mapWorkTimeSlot from './mapWorkTimeSlot';
import mapDayOfWeek from './mapDayOfWeek';

const mapWorkHours = (workHours: WorkHours[] | undefined): BookingWorkHoursInput[] | undefined => {
    if (!workHours) {
        return;
    }

    const modifiedWorkHours: BookingWorkHoursInput[] =
        workHours?.map(workHour => ({
            day: mapDayOfWeek(workHour.WorkDay as DayOfWeek),
            timeSlots: mapWorkTimeSlot(workHour.TimeSlots as WorkTimeSlot[]),
        })) ?? [];
    return modifiedWorkHours;
};

export default mapWorkHours;
